import styled from 'styled-components';

import {
  device
} from '../../utils';

export const Wrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 100%;

  a {
    font-weight: 500;
    font-size: 15px;
  }
  [data-oembed] {
    margin: 20px 0;
    width: 100%;
  }
  
  p {
    margin: 30px 0;
    &, a {
      font-size: 15px;
      line-height: 1.6em;
    }

    &:empty {
      display: none;
    }

    @media ${device.tablet} {
      margin: 25px 0;

      &, a {
        font-size: 17px;
        line-height: 1.7em;
      }
    }

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .gatsby-image-wrapper {
    width: 100%;
  }

  img {
    max-width: 100%;
  }

  picture {
    &.fr-dib {
      margin: 5px auto;
      display: block;
      float: none;
    
      &.fr-fil {
        margin-left: 0;
        text-align: left;
      }
    }
    &.fr-dii {
      display: inline-block;
      .fr-fil {
        float: left;
        margin: 5px 5px 5px 0;
      } 
    }
  }

  .block {
    display: block;
  }

  .centrer {
    text-align: center;
  }
  .aligner-droite {
    text-align: right;
  }

  .aligner-gauche {
    text-align: left;
  }
  ul {
    margin-left: 0;
    padding-left: 0;

    li {
      list-style: none;
      margin: 7px 0;

      &:before {
        content: '●';
        margin-right: 10px;
      }
    }
  }

  .bouton, .bouton-noir {
    a.simple-link {
      display: inline-block;
      border-radius: 30px;
      background-color: #c80f05;
      padding: 7px 20px;
      transition: background-color 300ms;

      color: #FFF;

      &:after {
        display: inline-block;
        color: #FFF;
      }

      &:before {
        display: none;
      }

      &:hover {
        background-color: #AF0D04;
      }
    }
  }


  .bouton-noir {
    a.simple-link {
      background-color: #000;

      &:hover {
        background-color: #292929;
      }
    }
  }
`;